export default "__VITE_PUBLIC_ASSET__b51db47b__"